angular
  .module("myApp")
  .controller(
    "EkspertuVertejumsLzpEditController",
    function (
      $scope,
      $timeout,
      uuiData,
      Dialog,
      Notification,
      Codifiers,
      LzpEkspertaVertejumsSubmit,
      LzpEkspertaVertejumsSet
    ) {
      this.init = (eksperts_id, ekspertize_id) => {
        // mani labojamie kritēriji
        this.eksperts_id = eksperts_id
        this.ekspertize_id = ekspertize_id
        this.pd_versija_id = $scope.dto.id

        this.load_kriteriji()
        // $scope.eksperta_info = eksperta_info
        // $scope.kriteriji = kriteriji

        // this.updateScore()
      }

      this.load_kriteriji = () => {
        uuiData.list(
          "lzp_eksperta_vertejums",
          {
            eksperts_id: this.eksperts_id,
            ekspertize_id: this.ekspertize_id,
            pd_versija_id: this.pd_versija_id,
          },
          update_kriteriji
        )
      }

      this.load_status = () => {
        uuiData.list(
          "lzp_eksperta_vertejums",
          {
            eksperts_id: this.eksperts_id,
            ekspertize_id: this.ekspertize_id,
            pd_versija_id: this.pd_versija_id,
          },
          (lzp_eksperta_vertejumi) => {
            const lzp_eksperta_vertejums = lzp_eksperta_vertejumi[0] // hack dēļ tā, ka lzp_eksperta_vertejums ir lists
            $scope.statuss = lzp_eksperta_vertejums.eksperts[0].statuss
            // pārējo neaiztiekam
          }
        )
      }

      const update_kriteriji = (lzp_eksperta_vertejumi) => {
        const lzp_eksperta_vertejums = lzp_eksperta_vertejumi[0] // hack dēļ tā, ka lzp_eksperta_vertejums ir lists

        const eksp_veids = lzp_eksperta_vertejums.veids

        $scope.statuss = lzp_eksperta_vertejums.eksperts[0].statuss

        Codifiers.kriteriji().$promise.then((ks) => {
          const out = []

          ks.forEach((k) => {
            if (k.karta_min && $scope.dto.pieteikumu_karta_id < k.karta_min) return
            if (k.karta_max && $scope.dto.pieteikumu_karta_id > k.karta_max) return
            if (k.datums_min && $scope.dto.iesniegsanas_datums < k.datums_min) return
            if (k.datums_max && $scope.dto.iesniegsanas_datums > k.datums_max) return

            if (eksp_veids === "LZP.NP" && !k.kriterija_kods.startsWith("lzp.np")) return
            if (eksp_veids === "LZP.PP" && !k.kriterija_kods.startsWith("lzp.pp")) return
            if (k.ir_saimniecisks === false && $scope.dto.ar_saimniecisku_darbibu_saistits) return
            if (k.ir_nesaimniecisks === false && !$scope.dto.ar_saimniecisku_darbibu_saistits) return

            const krit = { ...k }

            lzp_eksperta_vertejums.kriteriji.forEach((mk) => {
              if (mk.kriterija_kods === k.kriterija_kods) {
                krit.atbilstiba = mk.atbilstiba
                krit.komentars = mk.komentars
              }
            })

            out.push(krit)
          })
          $scope.kriteriji = out
        })
      }

      this.set = (crit, val) => {
        const commentable =
          (crit.veids === "NE-JA" || crit.veids === "NEATB-ATB") && crit.opcijas_json.silent !== true

        if (!commentable && crit.komentars) {
          crit.tmp_komentars = crit.komentars
          crit.komentars = void 0
        }
        if (commentable && crit.tmp_komentars) {
          crit.komentars = crit.tmp_komentars
          crit.tmp_komentars = void 0
        }
        if (commentable) {
          return Dialog.dialog(
            "pages/dialogs/comment.form.html",
            {
              komentars: crit.komentars,
              _allow_empty: val === "JA",
            },
            (p, action) => {
              if (action === "save") {
                crit.atbilstiba = val
                crit.komentars = p.komentars
                this.save()
              }
            }
          )
        }
        $scope.kriteriji.forEach((k) => {
          if (k.veids === "ONE-OF" && k.opcijas_json.tag === crit.opcijas_json.tag) {
            k.atbilstiba = "NE"
          }
        })
        crit.atbilstiba = val
        this.save()
      }

      this.submit = () => {
        const r = new LzpEkspertaVertejumsSubmit({
          id: this.ekspertize_id,
        })
        r.$create(() => {
          Notification.success("Jūsu vērtējums ir iesniegts, paldies!")
          this.load_kriteriji()
          $scope.reload()
        }, $scope.failing)
      }

      this.updateScore = () => {
        let score = 0
        $scope.kriteriji.forEach((k) => {
          if (k.atbilstiba === "JA" || k.atbilstiba === "AR_PIEZIMEM") {
            if (k.punkti) {
              score += k.punkti
            }
          }
        })
        $scope.score = score
        return score
      }

      let expsave

      this.save = () => {
        if (expsave) $timeout.cancel(expsave)

        expsave = $timeout(() => {
          expsave = undefined

          const d = {
            id: this.ekspertize_id,
            punkti: this.updateScore(),
            kriteriji: [],
          }
          _.each($scope.kriteriji, (k) => {
            if (k.atbilstiba) {
              d.kriteriji.push({
                kriterija_kods: k.kriterija_kods,
                atbilstiba: k.atbilstiba,
                komentars: k.komentars,
              })
            }
          })
          if (d.kriteriji.length > 0) {
            const v = new LzpEkspertaVertejumsSet(d)
            v.$save(this.load_status, $scope.failing)
          }
        }, 1000)
      }
    }
  )
  .controller(
    "EkspertuVertejumsOverviewController",
    function (
      $scope,
      uuiData,
      $stateParams,
      $timeout,
      Notification,
      PpRevertExpert,
      PpRevertExpertConsolidation,
      Codifiers
    ) {
      // gan ārējie, gan lzpa

      this.kla = Codifiers.kla
      this.sections = Codifiers.expert_sections

      this.iesniegts = (statuss) =>
        statuss === "IESNIEGTS" || statuss === "NORAIDITS" || statuss === "AKCEPTETS"

      $scope.rate = {
        YES: "Complies",
        NO: "Does not comply",
        COND: "Complies, with recommendations",
      }

      $scope.ae = {}
      $scope.headings = {
        adm_1_1: "Administratīvie kritēriji",
        atb_2_1: "Atbilstības kritēriji",
        izn_3_1: "Iznākuma kritēriji",
      }

      $scope.initialized = false

      this.reload = () => {
        const ae = uuiData.record("ekspertu_vertejumi", $stateParams.id)
        $scope.ae = ae

        ae.$promise
          .then(() => {
            ae.ekspertizes.forEach((ee) => {
              const statusi = {}
              let konsolidetajs = {}
              ee.eksperts.forEach((e) => {
                statusi[e.eksperts_id] = e.statuss
                if (e.ir_konsolidetajs) {
                  konsolidetajs = e
                  ee.cons_eksperts_id = e.eksperts_id
                }
              })
              ee.vertejums.forEach((v) => {
                // šis ir tikai ārējiem ekspertiem
                v.statuss = statusi[v.eksperts_id]
                if (!v.eksperts_id) {
                  ee.cons = v
                  ee.cons.eksperts = konsolidetajs
                } else {
                  // biome-ignore lint/suspicious/noDoubleEquals: <explanation>
                  if (v.eksperts_id == konsolidetajs.eksperts_id) {
                    v.ir_konsolidetajs = true
                  }
                }
              })
            })
          })
          .catch($scope.failing)

        if (!$scope.initialized) {
          $scope.dto.$promise.then(() => {
            Codifiers.kriteriji().$promise.then((ks) => {
              this.kriteriji = ks
              $scope.initialized = true
            })
          })
        }
      }

      this.revertExpertConsolidation = (ee) => {
        if (!confirm("Atcelt konsolidēto slēdzienu?")) {
          return
        }

        const dto = new PpRevertExpertConsolidation({
          id: $scope.dto.id,
          ekspertize_id: ee.id,
        })

        return dto.$save(() => {
          Notification.success("Atgriezts labošanai.")
          $scope.reload()
          $timeout(this.reload, 1000)
        }, $scope.failing)
      }

      this.revertExpertSubmission = (ee, e) => {
        if (!confirm("Atcelt eksperta vērtējumu?")) return

        const dto = new PpRevertExpert({
          id: $scope.dto.id,
          ekspertize_id: ee.id,
          eksperts_id: e.eksperts_id,
        })

        dto.$save(() => {
          Notification.success("Atgriezts labošanai.")
          $timeout(this.reload, 1000)
        }, $scope.failing)
      }

      this.reload()
    }
  )
